import { elvas } from "wg-fe-ui/dist/themes";

export let currentTheme = {};

export function getThemeObject() {
  return elvas();
}
